/*****
 * ====================================================================================
 * Project: noloPathSms jQuery Plugin
 * Description: provides support of noloPath SMS features
 * Author: Ian Cruz @ Nolo
 * Version: 1.0.0
 * jQuery Version: 2.1.3
 * ====================================================================================
 */




// noloPathSms JQUERY PLUGIN
// ====================================================================================
+function ($, window, document, undefined) {
    'use strict';

    // noloPathSms PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    // ================================================================================
    var noloPathSms = function (element, options) {
        this.$element = $(element);
        this.options  = $.extend(true, {}, noloPathSms.DEFAULTS, this.getDataAttributeOptions(), options);

        // Initialize the plugin
        this.init();
    }




    // noloPathSms PLUGIN NAME
    // ================================================================================
    noloPathSms.NAME = 'noloPathSms';
    noloPathSms.DATANAME = 'nolo.' + noloPathSms.NAME;




    // noloPathSms VERSION
    // ================================================================================
    noloPathSms.VERSION = '1.0.0';




    // noloPathSms DEFAULT OPTIONS
    // ================================================================================
    noloPathSms.DEFAULTS = {
        requestId: null,
        service: '//leads.nolo.com/index.php?r=nololeadgendelivery/rest/sms/sms-confirmation',
    }




    // noloPathSms PUBLIC METHODS
    // ================================================================================
    /**
     * Initializes the plugin
     * @params N/A
     * @return undefined
     */
    noloPathSms.prototype.init = function(){
        var confirmSms = $.proxy(this, 'confirmSms');
        var closeModal = $.proxy(this, 'closeModal');
        var $buttons = this.$element.find('button[data-dismiss="modal"]');
        var hasModal = this.detectBootstrapModal();

        // the Nolopath SMS notification modal requires Bootstrap 3 modal plugin
        if(hasModal){
            // trigger bootstrap 3's modal plugin;
            this.$element.modal();


            // bind the buttons to close the modal
            $buttons.each(function(idx){
                var $btn = $(this);

                $btn.on('click', function(event){
                    var $self = $(this);

                    // the button with the `data-agree` attribute will trigger the confirmation script
                    if ($self.data('agree')) {
                        confirmSms();
                    }
                });
            });
        }
    }


    noloPathSms.prototype.detectBootstrapModal = function() {
        if (typeof $.fn.modal === 'function'
            && $.fn.modal.Constructor.VERSION
            && $.fn.modal.Constructor.TRANSITION_DURATION
            && $.fn.modal.Constructor.BACKDROP_TRANSITION_DURATION){

            if(this.options.debug){
                console.info('Bootstrap 3 modal: ' + $.fn.modal.Constructor.VERSION);
            }

            return true;
        }

        console.error('Bootstrap 3 modal not available');

        return false;
    }


    noloPathSms.prototype.confirmSms = function() {
        var options = this.options;
        var process = this;
        var apiUrl = options.service;
        var delimiter = '?';

        // check if parameters are already set
        if(apiUrl.indexOf(delimiter)>-1){
            delimiter = '&';
        }

        // append the required skey
        apiUrl = apiUrl + delimiter + 'skey=' + options.requestId;

        // create the promise
        var promise = $.ajax({
            type: 'GET',
            crossDomain: true,
            url: apiUrl,
            dataType: 'json',
        });

        // on success, clean the data and cache it
        promise.done(function(data, status, xhr){
            return process.onAjaxSuccessSubmit(data, status, xhr);
        });

        // catch ajax errors
        promise.fail(function(xhr, status, error){
            return process.onAjaxErrorSubmit(xhr, status, error);
        });
    }


    noloPathSms.prototype.getDataAttributeOptions = function(){
        var options = this.$element.data();
        return options;
    }


    noloPathSms.prototype.onAjaxSuccessSubmit = function(data, status, xhr){
        if (data.status === 1 && data.message){
            console.info(data.message);
            if(this.options.debug){
                console.log(status);
            }
        }
        return;
    }


    noloPathSms.prototype.onAjaxErrorSubmit = function(xhr, status, error, $field){
        var data = {
            'xhr': xhr,
            'status': status,
            'error': error
        };

        // in case there is another error type, use this to generate a generic one
        this.setStatusError('genericOnAjaxErrorSubmit', 'error', 'Unable to process your request due to a server error', data);

        return false;
    }


    noloPathSms.prototype.setStatusError = function(id, status, errorMessage, errorData){
        console.error(errorMessage);
        if(this.options.debug){
            console.error(errorData);
        }
        return false;
    }




    // noloPathSms PLUGIN DEFINITION
    // ================================================================================
    function Plugin(option) {
        // store arguments into a local variable so we can reference it for the public methods
        var args = arguments;

        return this.each(function(idx) {
            var $this   = $(this);
            var data    = $this.data(noloPathSms.DATANAME);
            var options = typeof option == 'object' && option;

            // initialize the plugin for this element for the first time
            if (!data){
                // store the index of this particular instance so we can auto generate ids
                if(typeof options == 'object'){
                    // a configuration object was passed into the plugin
                    // add the 'idx' property into 'options'
                    options.idx = idx;
                } else {
                    // a configuration object was NOT passed into the plugin
                    // declare the 'options' variable as an object with at least the 'idx' property assigned to it
                    options = {
                        'idx': idx,
                    };
                }

                // store the instance of this plugin for this element into memory, if none exists
                // this will initialize the plugin using the 'options' configuration
                $this.data(noloPathSms.DATANAME, (data = new noloPathSms(this, options)));
            }

            // call a public method against the initialized plugin
            if (typeof option == 'string'){
                data[option].apply(this, Array.prototype.slice.call(args, 1));
            }
        })
    }

    // assign a previous plugin definition into another variable for 'noConflict'
    var old = $.fn[noloPathSms.NAME];

    // assign the noloPathSms PLUGIN DEFINITION
    $.fn[noloPathSms.NAME] = Plugin;

    // assign the noloPathSms PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    $.fn[noloPathSms.NAME]['constructor'] = noloPathSms;




    // noloPathSms NO CONFLICT
    // ================================================================================
    $.fn[noloPathSms.NAME]['noConflict'] = function () {
        $.fn[noloPathSms.NAME] = old;
        return this;
    }




    // noloPathSms DATA-API
    // ================================================================================
    $(document).ready(function(){
        // auto-initialize elements that contain the 'data-toggle="noloPathSms"' attribute
        var $elm = $('[data-toggle="noloPathSms"]');

        // pass a blank object to simplify the initialization
        // default plugin options and data attribute configuration options will be used for data-api initialization
        var option = {};

        // initialize the plugin upon document ready
        Plugin.call($elm, option);
    });
}(jQuery, window, document);
